module.exports = __webpack_public_path__ + "assets/a81d90a20cf7d76f62c6f4352121042e.svg";